import React from 'react';
import PropTypes from 'prop-types';

import NavigationBar from '../NavigationBar';
import PlanModal from '../PlanModal';

import styles from './styles.scss';

function AccountLayout({ children }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.layout}>
        <NavigationBar />
        <div className={styles.content}>
          {children}
        </div>
      </div>
      <PlanModal />
    </div>
  );
}

AccountLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AccountLayout;



// WEBPACK FOOTER //
// ./src/app/components/AccountLayout/index.js